module.exports = __webpack_public_path__ + "static/media/Header-bg-tablet-@1x.94a1e208.png";